export const LOADING_NOTIFICATIONS = "LOADING_NOTIFICATIONS";
export const SAVE_LOADING_NOTIFICATIONS = "SAVE_LOADING_NOTIFICATIONS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const FORM_NOTIFICATIONS_FAIL = "FORM_NOTIFICATIONS_FAIL";
export const NOTIFICATIONS_FAIL = "NOTIFICATIONS_FAIL";


